/**
 * 投影仪路由
 * */
export default [
  {
    path: "/projectorSystemIndex",
    name: "projectorSystemIndex",
    meta: {
      title: '首页'
    },
    component: () => import("@/views/projectorSystem/index")
  },{
    path: '/projectorSystemChannelList',
    name: 'projectorSystemChannelList',
    component: () => import('@/views/projectorSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },{
    path: '/projectorSystemMachineList',
    name: 'projectorSystemMachineList',
    component: () => import('@/views/projectorSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },{
    path: '/projectorSystemDeviceList',
    name: 'projectorSystemDeviceList',
    component: () => import('@/views/projectorSystem/deviceManage/deviceList'),
    meta: {
      title: '设备管理'
    }
  },{
    path: '/projectorSystemOtaManger',
    name: 'projectorSystemOtaManger',
    component: () => import('@/views/projectorSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },{
    path: '/projectorSystemOtaDownloadLogs',
    name: 'projectorSystemOtaDownloadLogs',
    component: () => import('@/views/projectorSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },{
    path: '/projectorSystemImeiErrorLogList',
    name: 'projectorSystemImeiErrorLogList',
    component: () => import('@/views/projectorSystem/deviceManage/imeiErrorLogList'),
    meta: {
      title: '设备日志'
    }
  },{
    path: '/projectorSystemAddModelPage',
    name: 'projectorSystemAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/projectorSystem/deviceManage/addModelPage')
  },{
    path: '/projectorSystemEditModelPage',
    name: 'projectorSystemEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/projectorSystem/deviceManage/editModelPage')
  },{
    path: '/projectorDeviceMonthRegister',
    name: 'projectorDeviceMonthRegister',
    meta: {
      title: '设备统计'
    },
    component: () => import('@/views/projectorSystem/bi/deviceMonthRegister')
  },{
    path: '/projectorSystemOtaUpdateAddPage',
    name: 'projectorSystemOtaUpdateAddPage',
    meta: {
      title: 'OTA新增'
    },
    component: () => import('@/views/projectorSystem/apply/otaUpdateAddPage')
  },{
    path: '/projectorSystemOtaUpdateEditPage',
    name: 'projectorSystemOtaUpdateEditPage',
    meta: {
      title: 'OTA编辑'
    },
    component: () => import('@/views/projectorSystem/apply/otaUpdateEditPage')
  },{
    path: '/projectorSystemDeviceQualityAssessment',
    name: 'projectorSystemDeviceQualityAssessment',
    meta: {
      title: '智能检测'
    },
    component: () => import('@/views/projectorSystem/deviceManage/deviceQualityAssessment')
  },{
    path: '/projectorSystemDeviceLogView',
    name: 'projectorSystemDeviceLogView',
    meta: {
      title: '设备日志'
    },
    component: () => import('@/views/projectorSystem/baby/deviceLogView'),
  },{
    path: '/projectorSystemSearchAppUse',
    name: 'projectorSystemSearchAppUse',
    component: () => import('@/views/projectorSystem/bi/searchAppUse'),
    meta: {
      title: '使用分析'
    },
  },{
    path: '/projectorSystemChannelAppPage',
    name: 'projectorSystemChannelAppPage',
    component: () => import('@/views/projectorSystem/deviceManage/ChannelAppPage'),
    meta: {
      title: '渠道APP关系管理'
    },
  },{
    path: '/projectorSystemOtaBiHome',
    name: 'projectorSystemOtaBiHome',
    component: () => import('@/views/projectorSystem/bi/otaBiHome'),
    meta: {
      title: 'OTA升级统计'
    },
  },{
    path: '/projectorSystemCheckModel',
    name: 'projectorSystemCheckModel',
    component: () => import('@/views/projectorSystem/deviceManage/checkModel'),
    meta: {
      title: '查看机型'
    }
  },
  {
    path: '/projectorKiDozApp',
    name: 'projectorKiDozApp',
    component: () => import("@/views/projectorSystem/bi/KiDozApp"),
    meta: {
      title: 'kiDozApp'
    }
  },
  {
    path: '/projectorOtaRequestLog',
    name: 'projectorOtaRequestLog',
    component: () => import("@/views/projectorSystem/bi/otaRequestLog"),
    meta: {
      title: 'ota请求日志'
    }
  }, {
    path: '/projectorVirtualSnBatchList',
    name: 'projectorVirtualSnBatchList',
    component: () => import("@/views/projectorSystem/deviceManage/virtualSnBatchList"),
    meta: {
      title: '授权批次'
    }
  }, {
    path: '/projectorVirtualSnLicenseList',
    name: 'projectorVirtualSnLicenseList',
    component: () => import("@/views/projectorSystem/deviceManage/virtualSnLicenseList"),
    meta: {
      title: '授权许可'
    }
  }, {
    path: '/projectorApkManager',
    name: 'projectorApkManager',
    component: () => import("@/views/projectorSystem/apply/apkManager"),
    meta: {
      title: 'APK管理'
    }
  },{
    path: '/projectorApkUpdateAddPage',
    name: 'projectorApkUpdateAddPage',
    meta: {
      title: 'Apk新增'
    },
    component: () => import('@/views/projectorSystem/apply/apkUpdateAddPage')
  },{
    path: '/projectorApkUpdateEditPage',
    name: 'projectorApkUpdateEditPage',
    meta: {
      title: 'Apk编辑'
    },
    component: () => import('@/views/projectorSystem/apply/apkUpdateEditPage')
  }, {
    path: '/projectorAppManager',
    name: 'projectorAppManager',
    component: () => import("@/views/projectorSystem/apply/appManager"),
    meta: {
      title: 'APP管理'
    }
  },{
    path: '/projectorAppUpdateAddPage',
    name: 'projectorAppUpdateAddPage',
    meta: {
      title: 'APP新增'
    },
    component: () => import('@/views/projectorSystem/apply/appUpdateAddPage')
  },{
    path: '/projectorAppUpdateEditPage',
    name: 'projectorAppUpdateEditPage',
    meta: {
      title: 'App编辑'
    },
    component: () => import('@/views/projectorSystem/apply/appUpdateEditPage')
  },
  {
    path: '/projectorDeviceInstruction',
    name: 'projectorDeviceInstruction',
    component: () => import('@/views/projectorSystem/deviceManage/deviceInstruction'),
    meta: {
      title: '设备指令'
    }
  },{
    path: '/projectorUserList',
    name: 'projectorUserList',
    component: () => import('@/views/projectorSystem/baby/photoUserList'),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/projectorSystem/movie/movieList',
    name: 'projectorSystem/movie/movieList',
    meta: {
      title: '电影资源'
    },
    component: () => import('@/views/projectorSystem/movie/movieList')
  },
  {
    path: '/projectorMaterialList',
    name: 'projectorMaterialList',
    meta: {
      title: '素材管理'
    },
    component: () => import('@/views/projectorSystem/material/MaterialList')
  },
  {
    path: '/projectorClassify',
    name: 'projectorClassify',
    meta: {
      title: '分类主题管理'
    },
    component: () => import('@/views/projectorSystem/material/Classify')
  },
  {
    path: '/projectorBannerList',
    name: 'projectorBannerList',
    meta: {
      title: 'Banner&视频'
    },
    component: () => import('@/views/projectorSystem/banner/bannerList')
  },
  {
    path: '/projector/movieCategory',
    name: 'movieCategory',
    meta: {
      title: '视频分类管理'
    },
    component:() => import('@/views/projectorSystem/movie/movieCategory')
  },
  {
    path: '/projectorSystem/movie/shortPlay',
    name: 'shortPlay',
    meta: {
      title: '短剧管理'
    },
    component: () => import('@/views/projectorSystem/movie/shortPlay')
  }
]



// WEBPACK FOOTER //
// ./src/router/projectorRouter.js